import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import AnalyticsEmptyState from "../../dashboard/AnalyticsEmptyState";

const OTHER_KEY = 'Anders, namelijk..';

const MultipleDevelopmentLineChart = ({ data = [], totalResponses, graphColor }) => {
  if (!data || data.length === 0) {
    return <AnalyticsEmptyState />;
  }

  // Recharts rows + hidden others
  const transformedData = data.map((entry) => {
    const row = { name: entry.moment, __others: entry.others || [] };
    entry.responses.forEach((response) => {
      row[response.name] = response.count;
    });
    return row;
  });

  // Options whose count is 0 in a moment are dropped upstream, so the response
  // set can differ per moment. Build the series from the union across all
  // moments — otherwise options that only appear in later moments never render.
  const seen = new Map();
  data.forEach((entry) => {
    entry.responses.forEach((r) => {
      if (!seen.has(r.name)) seen.set(r.name, { name: r.name, color: r.color });
    });
  });
  const options = Array.from(seen.values());

  // Custom tooltip with free-text list for OTHER_KEY
  const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length) return null;
    const row = payload[0]?.payload || {};
    const others = Array.isArray(row.__others) ? row.__others : [];
    const showOthers = payload.some((p) => p.dataKey === OTHER_KEY) && others.length > 0;

    return (
      <div className="multiple-dev-tooltip">
        <p className="multiple-dev-tooltip-label">{`Meetmoment: ${label}`}</p>

        {payload.map((entry) => (
          <p
            key={entry.dataKey}
            className="multiple-dev-tooltip-entry"
            style={{ color: entry.color }}
          >
            {`${entry.dataKey}: ${entry.value}`}
          </p>
        ))}

        {showOthers && (
          <div className="multiple-dev-tooltip-others">
            <div className="multiple-dev-tooltip-others-title">{OTHER_KEY}</div>
            <ul className="multiple-dev-tooltip-others-list">
              {others.slice(0, 5).map((txt, i) => (
                <li key={`other-${i}`}>{String(txt)}</li>
              ))}
            </ul>
            {others.length > 5 && (
              <div className="multiple-dev-tooltip-others-more">+{others.length - 5} meer…</div>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <ResponsiveContainer width="100%" height={400}>
        <LineChart data={transformedData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <XAxis dataKey="name" axisLine={false} tickLine={false} stroke={graphColor || 'black'} tick={{ fill: graphColor || undefined }} />
          <YAxis allowDecimals={false} axisLine={false} tickLine={false} stroke={graphColor || 'black'} tick={{ fill: graphColor || undefined }} />
          <Tooltip content={<CustomTooltip />} />
          <Legend layout="horizontal" verticalAlign="bottom" align="center" wrapperStyle={{ color: graphColor || undefined }} />
          {options.map((opt) => (
            <Line
              key={opt.name}
              type="monotone"
              dataKey={opt.name}
              stroke={opt.color}
              strokeWidth={3}
              activeDot={{ r: 6 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </>
  );
};

export default MultipleDevelopmentLineChart;
